
    window.columnHeaderNameKVP = window.columnHeaderNameKVP ?? {
        "_FundBlocks.Name.Ticker": "Ticker",
        "_FundBlocks.Name.Fund_Name": "Fund Name",
        "_FundBlocks.Name.1_MO": "1 MO*",
        "_FundBlocks.Name.YTD": "YTD*",
        "_FundBlocks.Name.1_YR": "1 YR",
        "_FundBlocks.Name.3_YR": "3 YR",
        "_FundBlocks.Name.5_YR": "5 YR",
        "_FundBlocks.Name.LIFE": "LIFE",
        "_FundBlocks.Name.Commenced": "Commenced",
        "_FundBlocks.Name.30_Day_SEC_Yield_4": "30 Day SEC Yield (%)<sup>4</sup>",
        "_FundBlocks.Name.Duration_Yrs": "Duration (Yrs)",
        "_FundBlocks.Name.Gross_Expense": "Gross Expense",
        "_FundBlocks.Name.Net_Expense": "Net Expense",
        "_FundBlocks.Name.Investment_Category": "Category"
    }

//Include the beat the bank JS
require('./common-fund-utils');

require('./jump-link-nav.js');

require('./yield-monitor-table.js');

require('./morningstar-table.js');

require('./yield-to-worst-table.js');

require('./yield-investment-returns-table.js');

require('./nav-price-table.js');